import { gql } from "@apollo/client";

export const GET_LAN_CONTROLLERS = gql`
  query ControllerInfo($domain: String!, $input: BasicQueryInfoInput!) {
    controller {
      info(domain: $domain, input: $input) {
        controller_id
        lan_controller_id
        system_id
        name
        cpu_id
      }
    }
  }
`

export interface LanControllerInfo {
  controller_id: number;
  lan_controller_id?: number
  cpu_id?: string;  
  system_id?: number;
  name?: string;
}

export interface LanControllersResponse {
  controller: {
    info: LanControllerInfo[]
  }
}